var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-employee" },
    [
      _c("BasePaySlipEmployeeHead", {
        attrs: {
          conditions: _vm.conditions,
          conditionIds: _vm.conditionIds,
          disabled: _vm.disabled
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.employeeList, function(employee, index) {
        return _c("BasePaySlipEmployeeItem", {
          key: index,
          attrs: {
            index: index,
            conditions: _vm.conditions,
            conditionIds: _vm.conditionIds,
            employees: _vm.employees,
            selectedEmployeeIds: _vm.selectedEmployeeIds,
            disabled: _vm.disabled,
            validateForm: _vm.employeeList[index].validateForm
          },
          on: {
            "update:validateForm": function($event) {
              return _vm.$set(_vm.employeeList[index], "validateForm", $event)
            },
            "update:validate-form": function($event) {
              return _vm.$set(_vm.employeeList[index], "validateForm", $event)
            },
            remove: _vm.handleRemoveItem
          },
          model: {
            value: _vm.employeeList[index],
            callback: function($$v) {
              _vm.$set(_vm.employeeList, index, $$v)
            },
            expression: "employeeList[index]"
          }
        })
      }),
      _vm._v(" "),
      !_vm.disabled
        ? _c(
            "div",
            [
              _c("BaseButton", { on: { click: _vm.onClickAdd } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("apps.payroll.button.addemployee")) +
                    "\n    "
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c8b9f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c8b9f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BasePaySlipEmployee.vue
// module id = null
// module chunks = 